<template>
  <div class="custom-report-container flex" :class="{ 'bg-white': noData }" v-loading="listLoading">
    <div v-if="noData" class="custom-report-container w100 flex vertical center">
      <img src="@/assets/img/v2/data-center/custom-report-empty.png" style="width: 240px; height: 146px;" />
      <span class="font-16 fw-500 color-3 mt6 mb40">{{ $t('noReport') }}</span>
      <el-button type="primary" class="button-v2" @click="addReport" v-if="!isReadOnly">+ {{ $t('customReport') }}</el-button>
    </div>

    <div v-else class="custom-report-list w100 flex wrap">
      <div class="custom-report-flex-box pr12" v-if="!isReadOnly">
        <div class="custom-report-box first-box">
          <img src="@/assets/img/v2/data-center/custom-report.png" style="width: 50px; height: 58px; margin-bottom: 25px;" />
          <el-button type="primary" class="button-v2" @click="addReport">+ {{ $t('customReport') }}</el-button>
        </div>
      </div>

      <div v-for="(item, index) in reportList" class="custom-report-flex-box" :class="{ pl12: (index + 1) % 4 !== 0, pr12: (index + 1) % 4 !== 3 }">
        <div class="custom-report-box">
          <div class="title-box">
            <span class="title-text text-ellipsis pr30" :title="item.REPORTNAME">{{ item.REPORTNAME }}</span>
            <i class="el-icon-close font-18 color-9 pointer" @click="handleDelete(item)" />
          </div>
          <div class="flex vertical pl24 pr24">
            <div class="flex acenter mt17">
              <i class="el-icon-s-tools color-9" />
              <span class="font-14 color-6 hl22 ml8">{{ reportTypeMap[item.REPORTTYPE]['codeItemName' + $i18n.locale] }}</span>
            </div>
            <div class="flex acenter mt14">
              <i class="el-icon-time color-9" />
              <span class="font-14 color-6 hl22 ml8">{{ $formatDateTime(item.CREATETIME) }}</span>
            </div>
            <div class="flex jend acenter mt16">
              <el-button plain class="button-v2" @click="editReport(item)" v-if="!isReadOnly">{{ $t('editReport') }}</el-button>
              <el-button type="primary" plain class="button-v2" @click="toDetail(item)">{{ $t('viewStatistics') }}</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog class="modal-v2" :title="reportModal.title" :visible.sync="reportModal.show" :close-on-click-modal="false" :width="reportModal.step === 1 ? '700px' : '1055px'" append-to-body>
      <div v-if="reportModal.step === 1" class="flex vertical">
        <el-form ref="reportForm" class="form-v2 report-form" :model="reportForm" :rules="reportFormRules" label-width="140px" style="margin: 40px 0; padding: 0 60px;" label-suffix="：">
          <el-form-item :label="$t('reportName')" prop="reportName">
            <el-input v-model="reportForm.reportName" class="input-v2" :placeholder="$t('enterReportName')" />
          </el-form-item>
          <el-form-item :label="$t('reportType')" prop="reportType">
            <el-radio-group class="radio-group-v2 vertical mt4" v-model="reportForm.reportType">
              <el-radio v-for="item in conditions.reportTypes" :label="item.codeItemId">{{ item['codeItemName' + $i18n.locale] }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>

      <div v-if="reportModal.step === 2" class="flex">
        <div class="w100 flex center" :class="{ 'caliber-small': reportModal.needAlgorithm }">
          <div class="caliber-box flex vertical">
            <el-input v-model="statisticTypeSearch" class="input-v2 gray mb22" style="flex: 0 0 32px" :placeholder="$t('searchStatisticalCaliber')" suffix-icon="el-icon-search" clearable />
            <div class="flex vertical astart pl15 overflow-y">
              <el-checkbox v-if="false" class="checkbox-v2 mb20" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAll">{{ $t('selectAll') }}</el-checkbox>
              <el-checkbox-group class="checkbox-group-v2 vertical" v-model="statisticTypeCheckedList" @change="handleChecked">
                <el-checkbox v-for="item in statisticTypeList" :key="item.codeItemId" :label="item">{{ item['codeItemName' + $i18n.locale] }}</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>

          <div class="caliber-box flex vertical">
            <span class="font-14 color-6 hl22 text-left ml4 mt4 mb16">{{lang == 'en' ? `${statisticTypeCheckedList.length} ${ $t('caliberSelected') }` : `已选：${statisticTypeCheckedList.length}个口径`}}</span>
            <draggable class="flex vertical astart pl15 overflow" v-model="statisticTypeCheckedList" handle=".handle" :force-fallback="true" ghost-class="draggable-ghost-v2">
              <div v-for="(item, index) in statisticTypeCheckedList" :key="item" class="flex acenter mb16" :style="{ paddingLeft: `${index * 15}px` }">
                <img src="@/assets/img/v2/common/drag.png" class="handle" style="width: 6px; height: 14px; margin-right: 15px; cursor: move;" />
                <span class="font-14 color-3 hl22 text-nowrap">{{ item['codeItemName' + $i18n.locale] }}</span>
              </div>
            </draggable>
          </div>
        </div>

        <div v-if="reportModal.needAlgorithm" class="flex jcenter" style="width: 454px; padding: 0 10px; -webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box;">
          <el-form ref="reportForm" class="form-v2 report-form mt40" :model="reportForm" :rules="reportFormRules" label-position="top" label-suffix="：">
            <el-form-item :label="$t('algorithm')" prop="algorithm">
              <el-radio-group class="radio-group-v2 vertical mt16" v-model="reportForm.algorithm">
                <el-radio v-for="item in conditions.algorithm" :label="item.codeItemId" style="white-space: normal">{{ item['codeItemName' + $i18n.locale] }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div slot="footer" class="w100 flex jbetween acenter">
        <el-button plain class="button-v2" @click="reportModal.show = false">{{ $t('cancel') }}</el-button>
        <div class="flex acenter">
          <el-button v-if="reportModal.step === 2" plain class="button-v2" @click="reportModal.step = 1">{{ $t('prevStep') }}</el-button>
          <el-button type="primary" class="button-v2" :loading="submitLoading" @click="nextStep">{{ reportModal.step === 1 && reportForm.reportType !== '92750005' ? $t('nextStep') : $t('done') }}</el-button>
        </div>
      </div>
    </el-dialog>

    <air-confirm-v2
        :show.sync="confirmShow"
        :title="confirmTitle"
        :content="confirmContent"
        :confirm-function="confirmFunction"
    ></air-confirm-v2>
  </div>
</template>

<script>
import * as apiCustomReport from '@/api/v2/stats/data-center/custom-report'
import draggable from 'vuedraggable'
import { mapGetters } from 'vuex';

export default {
  name: 'DataCenterCustomReport',
  components: {
    draggable
  },
  props: {
    search: {
      type: String,
      default: ''
    }
  },
  inject: ['$cusIds'],
  data() {
    return {
      submitLoading: false,
      listLoading: true,
      noData: true,
      allReportList: [],
      conditions: {},
      reportTypeMap: {},
      statisticTypeMap: {},
      reportModal: {
        title: this.$t('createCustomReport'), // 创建自定义报表
        show: false,
        step: 1,
        needAlgorithm: false
      },
      reportForm: {},
      reportFormRules: {
        reportName: [{ required: true, message: this.$t('enterReportName'), trigger: 'blur' }],
        reportType: [{ required: true, trigger: 'blur' }],
        algorithm: [{ required: true, trigger: 'blur' }],
      },
      checkAll: false,
      statisticTypeSearch: '',
      statisticTypeCheckedList: [],
      isIndeterminate: false,
      confirmShow: false,
      confirmTitle: '',
      confirmContent: '',
      confirmFunction: undefined,
    }
  },
  computed: {
    ...mapGetters([
      'isReadOnly',
      'lang'
    ]),
    reportList() {
      return this.allReportList.filter(item => item.REPORTNAME.includes(this.search))
    },
    statisticTypeList() {
      return this.conditions.statisticType.filter(item => item['codeItemName' + this.$i18n.locale].includes(this.statisticTypeSearch))
    },
    cusIds() {
      return this.$cusIds();
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      await this.getConditions()
      this.getData()
    },
    getConditions() {
      return apiCustomReport.conditions().then(res => {
        this.conditions = res.data.data
        this.reportTypeMap = this.$arrayToObj(this.conditions.reportTypes, 'codeItemId')
        this.statisticTypeMap = this.$arrayToObj(this.conditions.statisticType, 'codeItemId')
      })
    },
    getData() {
      const params = {
        cusIds: this.cusIds
      }
      apiCustomReport.list(params).then(res => {
        this.noData = !res.data.data.length
        this.allReportList = res.data.data
        this.listLoading = false
      })
    },
    toDetail(item) {
      this.$go('/v2/stats/data-center/custom-report-detail', { id: item.REPORTID, title: item.REPORTNAME, type: item.REPORTTYPE })
    },
    async addReport() {
      // 如果没有获取过字典数据
      if (!Object.keys(this.conditions).length) {
        await this.getConditions()
      }
      this.reportForm = {
        reportId: undefined,
        reportName: '',
        reportType: this.conditions.reportTypes[0].codeItemId,
        statisticType: '',
        algorithm: undefined,
      }
      this.statisticTypeCheckedList = []
      this.statisticTypeSearch = ''
      this.reportModal = {
        title: this.$t('createCustomReport'), // 创建自定义报表
        show: true,
        step: 1,
        needAlgorithm: false
      }
    },
    editReport(report, step = 1) {
      this.reportForm = {
        reportId: report.REPORTID,
        reportName: report.REPORTNAME,
        reportType: report.REPORTTYPE,
        statisticType: report.STATISTICTYPE,
        algorithm: report.ALGORITHM,
      }
      this.statisticTypeCheckedList = report.STATISTICTYPE.split(',').map(codeItemId => this.statisticTypeMap[codeItemId])
      this.reportModal = {
        title: this.$t('editCustomReport'),  // 编辑自定义报表
        show: true,
        step,
        needAlgorithm: false
      }
      this.reportModal.needAlgorithm = this.reportForm.reportType === '92750001'
    },
    nextStep() {
      if (this.reportModal.step < 2) {
        this.$refs.reportForm.validate(valid => {
          if (valid) {
            if (this.reportForm.reportType === '92750005') {
              // 如果是薪资项对比表，则直接保存
              this.handleSave()
            } else {
              this.reportModal.needAlgorithm = this.reportForm.reportType === '92750001'
              this.reportForm.algorithm = this.reportModal.needAlgorithm ? this.reportForm.algorithm || this.conditions.algorithm[0].codeItemId : undefined
              this.reportModal.step++
            }
          }
        })
      } else {
        if (!this.statisticTypeCheckedList.length) {
          this.$msgError(this.$t('selectStatisticalCaliber'))
          return
        }
        this.reportForm.statisticType = this.statisticTypeCheckedList.map(item => item.codeItemId).join(',')
        this.handleSave()
      }
    },
    handleSave() {
      this.submitLoading = true
      apiCustomReport.save(this.reportForm).then(res => {
        this.reportModal.show = false
        this.$go('/v2/stats/data-center/custom-report-detail', { id: res.data.data, title: this.reportForm.reportName, type: this.reportForm.reportType })
      }).finally(() => this.submitLoading = false)
    },
    handleCheckAll(val) {
      this.statisticTypeCheckedList = val ? this.statisticTypeList : []
      this.isIndeterminate = false
    },
    handleChecked(val) {
      this.checkAll = val.length === this.statisticTypeList.length
      this.isIndeterminate = val.length > 0 && val.length < this.statisticTypeList.length
    },
    handleDelete(item) {
      this.confirmShow = true
      this.confirmTitle = '删除报表'
      this.confirmContent = `确认删除报表「${item.REPORTNAME}」?`
      this.confirmFunction = () => {
        apiCustomReport.remove({
          reportId: item.REPORTID
        }).then(() => {
          this.getData()
          this.$msgSuccess('删除成功')
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/air/assets/css/main.scss";

.custom-report-container {
  min-height: calc(100vh - 377px);

  .custom-report-list {
    align-content: flex-start;

    .custom-report-flex-box {
      width: 25%;
      flex: 0 0 25%;
      height: 200px;
      margin-bottom: 24px;
    }
    .custom-report-box {
      width: 100%;
      height: 200px;
      display: flex;
      flex-direction: column;
      background: #FFFFFF;
      border-radius: 6px;

      &.first-box {
        background: #FFFCF8;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
.caliber-box {
  width: 372px;
  height: 477px;
  border-radius: 4px;
  border: 1px solid #E8E8E8;
  margin: 30px 0;
  padding: 14px;

  &:first-child {
    margin-right: 60px;
  }
}
.caliber-small {
  width: 600px;
  border-right: 1px solid #E8E8E8;

  .caliber-box {
    width: 219px;

    &:first-child {
      margin-right: 33px;
    }
  }
}
</style>
